import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { useTheme } from '@mui/material/styles'

export function StethoscopeIcon(props: SvgIconProps) {
  const { htmlColor } = props
  const theme = useTheme()
  return (
    <SvgIcon viewBox="0 0 200 200" sx={{ enableBackground: 'new 0 0 200 200' }} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Stethoscope">
        <g>
          <g id="XMLID_00000080170464963174300990000003329050815414440597_">
            <g>
              <path
                style={{
                  fill: htmlColor || '#A7A9AC',
                }}
                d="M183.081,150.382v22.03c0,6.93-5.62,12.55-12.55,12.55H29.471c-6.93,0-12.55-5.62-12.55-12.55
					v-22.6c0,0,0.07-0.1,0.19-0.28h164.97l0.17-0.14C182.521,149.722,182.801,150.052,183.081,150.382z"
              />
              <path
                style={{
                  fill: htmlColor || '#A7A9AC',
                }}
                d="M155.111,71.272c0,0.38,0,0.77-0.02,1.15c-0.6,30.53-25.54,55.09-56.22,55.09
					c-27.36,0-50.17-19.56-55.2-45.46c-0.67-3.49-1.03-7.09-1.03-10.78c0-31.06,25.18-56.23,56.23-56.23
					C129.931,15.042,155.111,40.212,155.111,71.272z M114.691,88.182v-5.65h-5.11v-4.36h-24.27v14.91h24.27v-4.9H114.691z
					 M108.651,40.752v-14.91l-21.3,14.91H108.651z M60.741,63.652v-4.58c0-1.14-0.46-2.16-1.2-2.9c-0.74-0.74-1.76-1.2-2.9-1.2
					c-2.26,0-4.1,1.83-4.1,4.1v4.58c0,2.26,1.84,4.1,4.1,4.1C58.911,67.752,60.741,65.912,60.741,63.652z"
              />
            </g>
            <g>
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M43.671,82.052c-0.67-3.49-1.03-7.09-1.03-10.78c0-31.06,25.18-56.23,56.23-56.23c31.06,0,56.24,25.17,56.24,56.23
					c0,0.38,0,0.77-0.02,1.15c-0.6,30.53-25.54,55.09-56.22,55.09C71.511,127.512,48.701,107.952,43.671,82.052z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M155.101,72.422c0,0-1.39,42.63,27.15,76.97c0.27,0.33,0.55,0.66,0.83,0.99v22.03c0,6.93-5.62,12.55-12.55,12.55H29.471
					c-6.93,0-12.55-5.62-12.55-12.55v-22.6c0,0,0.07-0.1,0.19-0.28c2.43-3.51,26.68-39.38,26.56-67.48"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					16.921,149.532 17.111,149.532 182.081,149.532 				"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M59.951,129.572c0,5.18-4.19,9.38-9.37,9.38s-9.37-4.2-9.37-9.38c0-5.17,4.19-9.37,9.37-9.37S59.951,124.402,59.951,129.572z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M157.521,129.572c0,5.18-4.2,9.38-9.37,9.38c-5.18,0-9.38-4.2-9.38-9.38c0-5.17,4.2-9.37,9.38-9.37
					C153.321,120.202,157.521,124.402,157.521,129.572z"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					78.261,110.982 81.851,110.982 87.351,110.982 92.851,110.982 98.351,110.982 103.841,110.982 109.341,110.982 114.841,110.982 
					119.271,110.982 				"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="81.851"
                y1="110.982"
                x2="81.851"
                y2="105.812"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="87.351"
                y1="110.982"
                x2="87.351"
                y2="105.812"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="92.851"
                y1="110.982"
                x2="92.851"
                y2="105.812"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="98.351"
                y1="110.982"
                x2="98.351"
                y2="105.812"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="103.841"
                y1="110.982"
                x2="103.841"
                y2="105.812"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="109.341"
                y1="110.982"
                x2="109.341"
                y2="105.812"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="114.841"
                y1="110.982"
                x2="114.841"
                y2="105.812"
              />

              <polygon
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					114.691,82.532 109.581,82.532 109.581,78.172 85.311,78.172 85.311,93.082 109.581,93.082 109.581,88.182 114.691,88.182 				
					"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M56.641,67.752c-2.26,0-4.1-1.84-4.1-4.1v-4.58c0-2.27,1.84-4.1,4.1-4.1c1.14,0,2.16,0.46,2.9,1.2c0.74,0.74,1.2,1.76,1.2,2.9
					v4.58C60.741,65.912,58.911,67.752,56.641,67.752z"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="69.281"
                y1="61.362"
                x2="126.271"
                y2="61.362"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					134.871,54.972 134.871,61.572 134.871,67.752 				"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					143.391,54.972 143.391,61.572 143.391,67.752 				"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="134.871"
                y1="61.572"
                x2="143.391"
                y2="61.572"
              />

              <polygon
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					108.651,25.842 108.651,40.752 87.351,40.752 				"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default StethoscopeIcon
